/* tslint:disable */
/* eslint-disable */
/**
 * gremiumhub
 * A platform for digital applications, approvals and discussions.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: denis.lugowski@gmail.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TableRowPresetDto } from './TableRowPresetDto';
import {
    TableRowPresetDtoFromJSON,
    TableRowPresetDtoFromJSONTyped,
    TableRowPresetDtoToJSON,
    TableRowPresetDtoToJSONTyped,
} from './TableRowPresetDto';
import type { SectionSpawnTriggerDto } from './SectionSpawnTriggerDto';
import {
    SectionSpawnTriggerDtoFromJSON,
    SectionSpawnTriggerDtoFromJSONTyped,
    SectionSpawnTriggerDtoToJSON,
    SectionSpawnTriggerDtoToJSONTyped,
} from './SectionSpawnTriggerDto';
import type { VisibilityConditionGroup } from './VisibilityConditionGroup';
import {
    VisibilityConditionGroupFromJSON,
    VisibilityConditionGroupFromJSONTyped,
    VisibilityConditionGroupToJSON,
    VisibilityConditionGroupToJSONTyped,
} from './VisibilityConditionGroup';
import type { FormElementType } from './FormElementType';
import {
    FormElementTypeFromJSON,
    FormElementTypeFromJSONTyped,
    FormElementTypeToJSON,
    FormElementTypeToJSONTyped,
} from './FormElementType';
import type { FormOptionDto } from './FormOptionDto';
import {
    FormOptionDtoFromJSON,
    FormOptionDtoFromJSONTyped,
    FormOptionDtoToJSON,
    FormOptionDtoToJSONTyped,
} from './FormOptionDto';

/**
 * 
 * @export
 * @interface FormElementSnapshotDto
 */
export interface FormElementSnapshotDto {
    /**
     * 
     * @type {string}
     * @memberof FormElementSnapshotDto
     */
    reference?: string;
    /**
     * 
     * @type {string}
     * @memberof FormElementSnapshotDto
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof FormElementSnapshotDto
     */
    description?: string;
    /**
     * Legal statement. `{{wert}}` is replaced with the rendered field value.
     * @type {string}
     * @memberof FormElementSnapshotDto
     */
    statement?: string;
    /**
     * Longer plain-text explanation shown in a popover behind an info icon next to the question title. Line breaks are kept. Not part of document exports.
     * @type {string}
     * @memberof FormElementSnapshotDto
     */
    clarification?: string;
    /**
     * 
     * @type {FormElementType}
     * @memberof FormElementSnapshotDto
     */
    type: FormElementType;
    /**
     * 
     * @type {Array<FormOptionDto>}
     * @memberof FormElementSnapshotDto
     */
    options: Array<FormOptionDto>;
    /**
     * 
     * @type {VisibilityConditionGroup}
     * @memberof FormElementSnapshotDto
     */
    visibilityConditions?: VisibilityConditionGroup | null;
    /**
     * 
     * @type {Array<SectionSpawnTriggerDto>}
     * @memberof FormElementSnapshotDto
     */
    sectionSpawnTriggers?: Array<SectionSpawnTriggerDto>;
    /**
     * 
     * @type {boolean}
     * @memberof FormElementSnapshotDto
     */
    isClonable?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FormElementSnapshotDto
     */
    isRequired?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FormElementSnapshotDto
     */
    isVisibleInDocumentExport?: boolean;
    /**
     * 
     * @type {Array<TableRowPresetDto>}
     * @memberof FormElementSnapshotDto
     */
    crossTableDerivedRows?: Array<TableRowPresetDto>;
}



/**
 * Check if a given object implements the FormElementSnapshotDto interface.
 */
export function instanceOfFormElementSnapshotDto(value: object): value is FormElementSnapshotDto {
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('options' in value) || value['options'] === undefined) return false;
    return true;
}

export function FormElementSnapshotDtoFromJSON(json: any): FormElementSnapshotDto {
    return FormElementSnapshotDtoFromJSONTyped(json, false);
}

export function FormElementSnapshotDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): FormElementSnapshotDto {
    if (json == null) {
        return json;
    }
    return {
        
        'reference': json['reference'] == null ? undefined : json['reference'],
        'title': json['title'] == null ? undefined : json['title'],
        'description': json['description'] == null ? undefined : json['description'],
        'statement': json['statement'] == null ? undefined : json['statement'],
        'clarification': json['clarification'] == null ? undefined : json['clarification'],
        'type': FormElementTypeFromJSON(json['type']),
        'options': ((json['options'] as Array<any>).map(FormOptionDtoFromJSON)),
        'visibilityConditions': json['visibilityConditions'] == null ? undefined : VisibilityConditionGroupFromJSON(json['visibilityConditions']),
        'sectionSpawnTriggers': json['sectionSpawnTriggers'] == null ? undefined : ((json['sectionSpawnTriggers'] as Array<any>).map(SectionSpawnTriggerDtoFromJSON)),
        'isClonable': json['isClonable'] == null ? undefined : json['isClonable'],
        'isRequired': json['isRequired'] == null ? undefined : json['isRequired'],
        'isVisibleInDocumentExport': json['isVisibleInDocumentExport'] == null ? undefined : json['isVisibleInDocumentExport'],
        'crossTableDerivedRows': json['crossTableDerivedRows'] == null ? undefined : ((json['crossTableDerivedRows'] as Array<any>).map(TableRowPresetDtoFromJSON)),
    };
}

export function FormElementSnapshotDtoToJSON(json: any): FormElementSnapshotDto {
    return FormElementSnapshotDtoToJSONTyped(json, false);
}

export function FormElementSnapshotDtoToJSONTyped(value?: FormElementSnapshotDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'reference': value['reference'],
        'title': value['title'],
        'description': value['description'],
        'statement': value['statement'],
        'clarification': value['clarification'],
        'type': FormElementTypeToJSON(value['type']),
        'options': ((value['options'] as Array<any>).map(FormOptionDtoToJSON)),
        'visibilityConditions': VisibilityConditionGroupToJSON(value['visibilityConditions']),
        'sectionSpawnTriggers': value['sectionSpawnTriggers'] == null ? undefined : ((value['sectionSpawnTriggers'] as Array<any>).map(SectionSpawnTriggerDtoToJSON)),
        'isClonable': value['isClonable'],
        'isRequired': value['isRequired'],
        'isVisibleInDocumentExport': value['isVisibleInDocumentExport'],
        'crossTableDerivedRows': value['crossTableDerivedRows'] == null ? undefined : ((value['crossTableDerivedRows'] as Array<any>).map(TableRowPresetDtoToJSON)),
    };
}

